// extracted by mini-css-extract-plugin
export default {"limitWidth":"AddClass_limitWidth__9sdSR"};